export const types = {
    TEXTREAD: 'TEXT-READ',
    TEXTSAVE: 'TEXT-SAVE'
};